import { render } from "./SystemText.vue?vue&type=template&id=55a9ae96"
import script from "./SystemText.vue?vue&type=script&lang=js"
export * from "./SystemText.vue?vue&type=script&lang=js"

import "./SystemText.vue?vue&type=style&index=0&id=55a9ae96&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__